import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService, GetTokenSilentlyOptions } from '@auth0/auth0-angular';
import { environment } from '@env/environment';
import { Observable, catchError, of, switchMap, tap } from 'rxjs';

export const baseUrls = [...environment.cloudMedApiBaseUrls.map((url) => environment.api[url])].filter(Boolean);

@Injectable()
export class CmaiHttpInterceptor implements HttpInterceptor {
  private token = null;

  constructor(private readonly authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!baseUrls.some((baseUrl) => req.url.startsWith(baseUrl))) {
      return next.handle(req);
    }

    return this.getAuthToken().pipe(
      switchMap((token) => {
        const clone = req.clone({
          headers: req.headers.set('Authorization', `Bearer ${token}`),
        });
        return next.handle(clone);
      })
    );
  }

  private getAuthToken(): Observable<string | void> {
    if (this.token) {
      return of(this.token);
    }

    const options: GetTokenSilentlyOptions = {
      authorizationParams: { audience: environment.auth0Config.cmaiAudience },
    };

    return this.authService.getAccessTokenSilently(options).pipe(
      catchError((err) => {
        if (err?.toString()?.includes('Consent required') || err?.toString()?.includes('Login required')) {
          return this.authService.getAccessTokenWithPopup(options);
        }
        return of(null);
      }),
      tap((token) => {
        this.token = token;
      })
    );
  }
}
